/* Auto-generated — do not edit */
const DISTRICT_DATA = [
  {
    "name": "Ariyalur",
    "blocks": 6,
    "highConcBlocks": "Ariyalur Thirumanur Sendurai Jayankondam Andimadam T.Palur",
    "scstVillages40plus": 201,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 497384,
        "pct": 75.24,
        "remarks": null
      },
      "sc": {
        "count": 163770,
        "pct": 23.34,
        "remarks": null
      },
      "st": {
        "count": 9946,
        "pct": 1.42,
        "remarks": null
      },
      "total": {
        "count": 671100,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 269582,
        "female": 211022,
        "total": 480604
      },
      "sc": {
        "male": null,
        "female": null,
        "total": null
      },
      "st": {
        "male": null,
        "female": null,
        "total": null
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 25,
      "boys": {
        "count": 588,
        "classX_pct": 85,
        "classXII_pct": 78
      },
      "girls": {
        "count": 589,
        "classX_pct": 91,
        "classXII_pct": 96
      },
      "total": {
        "count": 1177,
        "classX_pct": 88,
        "classXII_pct": 85
      },
      "teachers": {
        "general": {
          "sanctioned": 13,
          "actual": 12,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 67,
          "actual": 44,
          "vacant_pct": 34
        },
        "st": {
          "sanctioned": 1,
          "actual": 1,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 4,
      "new_since_2026": null,
      "more_than_1yr": 4,
      "contempt": 1,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": 1,
      "new": 1,
      "rating_a": 5,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 19,
      "disposed": 16,
      "pending": 3,
      "appeal1": 5,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 42,
      "more_1yr": 37,
      "more_3yr": 5,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": 190,
      "villages_without": 39,
      "common_no_discrimination": 2,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": 1,
      "no_all_weather_roads": 0
    },
    "drinking_water": {
      "connections_provided": 0,
      "pending": 0
    },
    "buildings": {
      "hostel": {
        "y20_30": 3,
        "y30_40": 5,
        "y40_plus": 4,
        "stability_cert": "YES"
      },
      "school": {
        "y20_30": 11,
        "y30_40": 3,
        "y40_plus": 5,
        "stability_cert": "YES"
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Chengalpattu",
    "blocks": 8,
    "highConcBlocks": "St.Thamas Mount",
    "scstVillages40plus": 44,
    "scHabitations": 28,
    "stHabitations": 16,
    "population": {
      "general": {
        "count": 2161240,
        "pct": null,
        "remarks": null
      },
      "sc": {
        "count": 651334,
        "pct": 360,
        "remarks": "St.Thamas Mount ( Sc-235568, | Chittamur - 49% Lathur - 45.3 %"
      },
      "st": {
        "count": 28998,
        "pct": 0,
        "remarks": "St-8047 | Triruporur - 2.6% And Achirupakkam- 2.4 % Blocks"
      },
      "total": {
        "count": 680332,
        "pct": 243615,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 89.89,
        "female": 79.02,
        "total": null
      },
      "sc": {
        "male": 23.7,
        "female": null,
        "total": null
      },
      "st": {
        "male": 1,
        "female": null,
        "total": null
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 14,
        "girls": 8,
        "total": 22
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 58,
      "boys": {
        "count": 82,
        "classX_pct": 89,
        "classXII_pct": null
      },
      "girls": {
        "count": 85,
        "classX_pct": 91,
        "classXII_pct": null
      },
      "total": {
        "count": 83,
        "classX_pct": 90,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 393,
          "actual": 393,
          "vacant_pct": 284
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 1,
      "boys": {
        "count": 186,
        "classX_pct": 186,
        "classXII_pct": 100
      },
      "girls": {
        "count": 133,
        "classX_pct": 133,
        "classXII_pct": 100
      },
      "total": {
        "count": 319,
        "classX_pct": 319,
        "classXII_pct": 100
      },
      "teachers": {
        "general": {
          "sanctioned": 21,
          "actual": 52,
          "vacant_pct": 10
        },
        "sc": {
          "sanctioned": 9,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 2,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": null,
      "new_since_2026": 1,
      "more_than_1yr": null,
      "contempt": null,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": null,
      "new": null,
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 4,
      "disposed": 3,
      "pending": 1,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": null,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Chennai",
    "blocks": "15 ( Zones )",
    "highConcBlocks": null,
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 4646732,
        "pct": 15.52,
        "remarks": null
      },
      "sc": {
        "count": 779667,
        "pct": 16.78,
        "remarks": null
      },
      "st": {
        "count": 10061,
        "pct": 0.22,
        "remarks": null
      },
      "total": {
        "count": 789728,
        "pct": 17.0,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 93.7,
        "female": 86.6,
        "total": 90.15
      },
      "sc": {
        "male": 88.79,
        "female": 78.52,
        "total": 83.65
      },
      "st": {
        "male": 76.52,
        "female": 73.73,
        "total": 75.12
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 18,
      "boys": {
        "count": 1031,
        "classX_pct": 0.8,
        "classXII_pct": 0.8
      },
      "girls": {
        "count": 933,
        "classX_pct": 0.92,
        "classXII_pct": 0.81
      },
      "total": {
        "count": 1964,
        "classX_pct": 0.85,
        "classXII_pct": 0.805
      },
      "teachers": {
        "general": {
          "sanctioned": 170,
          "actual": 106,
          "vacant_pct": 0.37
        },
        "sc": {
          "sanctioned": 71,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 1,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 6,
      "new_since_2026": null,
      "more_than_1yr": 1,
      "contempt": null,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": 14,
      "new": 1,
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 17,
      "disposed": 16,
      "pending": 1,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": null,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouuseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Coimbatore",
    "blocks": null,
    "highConcBlocks": null,
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 3458045,
        "pct": 83.7,
        "remarks": null
      },
      "sc": {
        "count": 535911,
        "pct": 15.5,
        "remarks": null
      },
      "st": {
        "count": 28342,
        "pct": 0.82,
        "remarks": null
      },
      "total": {
        "count": null,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 89.06,
        "female": 78.92,
        "total": 83.93
      },
      "sc": {
        "male": 75.59,
        "female": 62.35,
        "total": 68.94
      },
      "st": {
        "male": 71.89,
        "female": 60.64,
        "total": 66.16
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "sc": {
        "boys": 11,
        "girls": 0,
        "total": 11
      },
      "st": {
        "boys": 3,
        "girls": 1,
        "total": 4
      }
    },
    "section4_adw": {
      "schools": 16,
      "boys": {
        "count": 377,
        "classX_pct": 0.94,
        "classXII_pct": 0.91
      },
      "girls": {
        "count": 454,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 831,
        "classX_pct": 0.94,
        "classXII_pct": 0.94
      },
      "teachers": {
        "general": {
          "sanctioned": 59,
          "actual": 20,
          "vacant_pct": 0.07
        },
        "sc": {
          "sanctioned": 34,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 1,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 15,
      "boys": {
        "count": 377,
        "classX_pct": 1,
        "classXII_pct": 1
      },
      "girls": {
        "count": 400,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 777,
        "classX_pct": 1,
        "classXII_pct": 1
      },
      "teachers": {
        "general": {
          "sanctioned": 58,
          "actual": 11,
          "vacant_pct": 0.03
        },
        "sc": {
          "sanctioned": 45,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 0,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 8,
      "new_since_2026": 0,
      "more_than_1yr": 8,
      "contempt": 1,
      "ca_not_filed": 0
    },
    "cm_cell": {
      "pending": 36,
      "new": 155,
      "rating_a": 4,
      "rating_b": 3,
      "rating_c": 5
    },
    "rti": {
      "received": 55,
      "disposed": 50,
      "pending": 5,
      "appeal1": 0,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 0,
      "more_1yr": 0,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": 0,
      "villages_without": 0,
      "common_no_discrimination": 0,
      "encroachments": 0
    },
    "transport": {
      "no_public_transport": 13,
      "no_all_weather_roads": 410
    },
    "drinking_water": {
      "connections_provided": 23687,
      "pending": 0
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of House Holds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": 18
    },
    "electricity": {
      "no_habitations": 17,
      "no_households": 475
    }
  },
  {
    "name": "Cuddalore",
    "blocks": 14,
    "highConcBlocks": "Virudhachalam, Kurinchipadi, Parangipettai, Nallur",
    "scstVillages40plus": 382,
    "scHabitations": 382,
    "stHabitations": 683,
    "population": {
      "general": {
        "count": 3441450,
        "pct": null,
        "remarks": null
      },
      "sc": {
        "count": 1219844,
        "pct": 35.4,
        "remarks": null
      },
      "st": {
        "count": 614018,
        "pct": 17.8,
        "remarks": null
      },
      "total": {
        "count": null,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 1269766,
        "female": 982324,
        "total": 2252090
      },
      "sc": {
        "male": 40722,
        "female": 31818,
        "total": 72540
      },
      "st": {
        "male": 1475,
        "female": 858,
        "total": 2333
      },
      "total": {
        "male": 1311963,
        "female": 1015000,
        "total": 2326963
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 24,
        "girls": 8,
        "total": 32
      },
      "sc": {
        "boys": 24,
        "girls": 8,
        "total": 32
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 126,
      "boys": {
        "count": 3839,
        "classX_pct": 92,
        "classXII_pct": 98
      },
      "girls": {
        "count": 3554,
        "classX_pct": 97,
        "classXII_pct": 95
      },
      "total": {
        "count": 7393,
        "classX_pct": 94,
        "classXII_pct": 97
      },
      "teachers": {
        "general": {
          "sanctioned": 21,
          "actual": 21,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 443,
          "actual": 276,
          "vacant_pct": 167
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 1,
      "boys": {
        "count": 37,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 27,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 64,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 17,
          "actual": 2,
          "vacant_pct": 15
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 14,
      "new_since_2026": 12,
      "more_than_1yr": 14,
      "contempt": null,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": 22,
      "new": 18,
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 57,
      "disposed": 53,
      "pending": 4,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": "NILL",
      "more_1yr": "NILL",
      "more_3yr": "NILL",
      "more_5yr": "NILL"
    },
    "burial_grounds": {
      "total_scst": 618,
      "villages_without": 6,
      "common_no_discrimination": "NIL",
      "encroachments": "NIL"
    },
    "transport": {
      "no_public_transport": "NIL",
      "no_all_weather_roads": "NIL"
    },
    "drinking_water": {
      "connections_provided": "NIL",
      "pending": "NIL"
    },
    "buildings": {
      "61 - hostels 126 - school": {
        "y20_30": "20 - hostel 34 - School",
        "y30_40": "7 - hostel 16 - school",
        "y40_plus": "5 - hostel 7 - school",
        "stability_cert": "for Darmanallur Social Justice Girls Hostel."
      },
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "NIL"
    },
    "electricity": {
      "no_habitations": "NIL",
      "no_households": "NIL"
    }
  },
  {
    "name": "Dharmapuri",
    "blocks": null,
    "highConcBlocks": null,
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 1506843,
        "pct": 100,
        "remarks": null
      },
      "sc": {
        "count": 245479,
        "pct": 16.29,
        "remarks": null
      },
      "st": {
        "count": 63044,
        "pct": 4.18,
        "remarks": null
      },
      "total": {
        "count": null,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.7685,
        "female": 0.598,
        "total": 0.6854
      },
      "sc": {
        "male": 0.1611,
        "female": 0.1648,
        "total": 0.1629
      },
      "st": {
        "male": 0.0415,
        "female": 0.0422,
        "total": 0.0418
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 10,
      "boys": {
        "count": 284,
        "classX_pct": 0.75,
        "classXII_pct": 0.91
      },
      "girls": {
        "count": 295,
        "classX_pct": 0.99,
        "classXII_pct": 0.82
      },
      "total": {
        "count": 579,
        "classX_pct": 0.87,
        "classXII_pct": 0.87
      },
      "teachers": {
        "general": {
          "sanctioned": 43,
          "actual": 10,
          "vacant_pct": 0.13
        },
        "sc": {
          "sanctioned": 25,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 2,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 32,
      "boys": {
        "count": 1011,
        "classX_pct": 0.92,
        "classXII_pct": 0.95
      },
      "girls": {
        "count": 898,
        "classX_pct": 1,
        "classXII_pct": 1
      },
      "total": {
        "count": 1909,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 165,
          "actual": 84,
          "vacant_pct": 0.4909
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 13,
      "new_since_2026": 3,
      "more_than_1yr": 10,
      "contempt": 0,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": 38,
      "new": 38,
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 37,
      "disposed": 33,
      "pending": "4 (New Cases)",
      "appeal1": 0,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 0,
      "more_1yr": 0,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": 143,
      "villages_without": 1,
      "common_no_discrimination": 1,
      "encroachments": 1
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "dadwo no. of schools -10 no. of buildings - 26": {
        "y20_30": "Below 20 Yrs - 10 Between 20 to 30 Yrs - 13",
        "y30_40": 0,
        "y40_plus": 3,
        "stability_cert": null
      },
      "dadwo hostels - 33": {
        "y20_30": "Below 20 Yrs - 11 Between 20 to 30 Yrs - 15",
        "y30_40": 2,
        "y40_plus": 5,
        "stability_cert": "Stability certificate obtained for 7 Hostels. Documents uploaded in BJRCY scheme for allocation of funds"
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Dindigul",
    "population": {
      "general": {
        "count": 1699335,
        "pct": 2.99,
        "remarks": null
      },
      "sc": {
        "count": 452376,
        "pct": 20.9,
        "remarks": null
      },
      "st": {
        "count": 8064,
        "pct": 37.0,
        "remarks": null
      },
      "total": {
        "count": 2159775,
        "pct": 24.26,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 816180,
        "female": 665654,
        "total": 1481834
      },
      "sc": {
        "male": 154237,
        "female": 121484,
        "total": 275721
      },
      "st": {
        "male": 2028,
        "female": 1602,
        "total": 3630
      },
      "total": {
        "male": 972445,
        "female": 788740,
        "total": 1761185
      }
    },
    "section3_dropout": {
      "sc": {
        "boys": 1,
        "girls": 1,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "total": {
        "boys": 1,
        "girls": 1,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 7,
      "boys": {
        "count": 47,
        "classX_pct": 100,
        "classXII_pct": 100
      },
      "girls": {
        "count": 29,
        "classX_pct": 100,
        "classXII_pct": 90
      },
      "total": {
        "count": 76,
        "classX_pct": 100,
        "classXII_pct": 95
      },
      "teachers": {
        "general": {
          "sanctioned": 5,
          "actual": 5,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 15,
          "actual": 13,
          "vacant_pct": 2
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {},
    "court_cases": {
      "pending": 8,
      "new_since_2026": "NIL",
      "more_than_1yr": 8,
      "contempt": 1,
      "ca_not_filed": "NIL"
    },
    "cm_cell": {
      "pending": 34,
      "new": 98,
      "rating_a": 28,
      "rating_b": 36,
      "rating_c": "NIL"
    },
    "rti": {
      "received": 15,
      "disposed": 14,
      "pending": 1,
      "appeal1": "NIL",
      "appeal_commission": "NIL"
    },
    "pending_files": {
      "total": "NIL",
      "more_1yr": "NIL",
      "more_3yr": "NIL",
      "more_5yr": "NIL"
    },
    "burial_grounds": {
      "total_scst": 232,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": 2
    },
    "transport": {
      "no_public_transport": "VADAGAVUNJI PANCHAYAT(PERUMPALLAM) TO PACHALUR PANCHAYAT(KADAISIKADU )",
      "no_all_weather_roads": "KARUVELAMPATTY, PERUMPALLAM,VADAGAVUNJI PANCHAYAT"
    },
    "drinking_water": {
      "connections_provided": 503,
      "pending": "NIL"
    },
    "buildings": {
      "mobile networks": {
        "y20_30": "NO OF HABITATIONS NOT HAVE MOBIE ACCESS",
        "y30_40": "NO OF HOUSE HOLD NOT HAVE ELECTRIVCITY",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "VADAGAVUNJI(SAVARIKADU, KADAMANRAAVU, KOMBAIKAADU, PATTIYAKADU, KARUVELAMPATTY)"
    },
    "electricity": {
      "no_habitations": "PANNAIKADU (VALANGULAM)",
      "no_households": "PANNAIKADU (VALANGULAM)"
    }
  },
  {
    "name": "Erode",
    "blocks": 14,
    "highConcBlocks": null,
    "scstVillages40plus": 13,
    "scHabitations": 225,
    "stHabitations": 35,
    "population": {
      "general": {
        "count": 2015971,
        "pct": 89.0,
        "remarks": null
      },
      "sc": {
        "count": 216689,
        "pct": 10.0,
        "remarks": null
      },
      "st": {
        "count": 19084,
        "pct": 1.0,
        "remarks": null
      },
      "total": {
        "count": 2251744,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.8042,
        "female": 0.6471,
        "total": 0.7258
      },
      "sc": {
        "male": 0.6641,
        "female": 0.521,
        "total": 0.5923
      },
      "st": {
        "male": 0.61,
        "female": 0.4,
        "total": 0.5923
      },
      "total": {
        "male": 0.8042,
        "female": 0.6471,
        "total": 0.7258
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "sc": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 4,
      "boys": {
        "count": 56,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "girls": {
        "count": 6,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "total": {
        "count": 62,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 12,
          "actual": 9,
          "vacant_pct": 0.25
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {
      "schools": 22,
      "boys": {
        "count": 442,
        "classX_pct": 0.89,
        "classXII_pct": 1
      },
      "girls": {
        "count": 470,
        "classX_pct": 0.93,
        "classXII_pct": 0.98
      },
      "total": {
        "count": 912,
        "classX_pct": 0.86,
        "classXII_pct": 0.99
      },
      "teachers": {
        "general": {
          "sanctioned": 12,
          "actual": 12,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 112,
          "actual": 44,
          "vacant_pct": 0.61
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "court_cases": {
      "pending": 13,
      "new_since_2026": null,
      "more_than_1yr": 13,
      "contempt": 0,
      "ca_not_filed": 0
    },
    "cm_cell": {
      "pending": 5,
      "new": 0,
      "rating_a": 12,
      "rating_b": 0,
      "rating_c": 2
    },
    "rti": {
      "received": 48,
      "disposed": 41,
      "pending": 7,
      "appeal1": 0,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 0,
      "more_1yr": 0,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": 225,
      "villages_without": 0,
      "common_no_discrimination": 0,
      "encroachments": 0
    },
    "transport": {
      "no_public_transport": "1. Kathirimalai",
      "no_all_weather_roads": "1. Kathirimalai 2.Sundapur. 3.Tholli,4. Velampatti."
    },
    "drinking_water": {
      "connections_provided": 219,
      "pending": 0
    },
    "buildings": {
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": 13
    },
    "electricity": {
      "no_habitations": "No",
      "no_households": "No"
    }
  },
  {
    "name": "Kallakurichi",
    "blocks": 9,
    "highConcBlocks": "SC Population: Kallakurichi Block-64079 ST Population: Kalrayan Hills Block-45176",
    "scstVillages40plus": 32,
    "scHabitations": 255,
    "stHabitations": 103,
    "population": {
      "general": {
        "count": 914339,
        "pct": 66.0,
        "remarks": null
      },
      "sc": {
        "count": 422628,
        "pct": 30.0,
        "remarks": null
      },
      "st": {
        "count": 50475,
        "pct": 4.0,
        "remarks": null
      },
      "total": {
        "count": 1387442,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 316386,
        "female": 253603,
        "total": null
      },
      "sc": {
        "male": 149610,
        "female": 99740,
        "total": null
      },
      "st": {
        "male": 4845,
        "female": 1212,
        "total": null
      },
      "total": {
        "male": 470841,
        "female": 354555,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 112,
        "girls": 61,
        "total": 173
      },
      "sc": {
        "boys": 1,
        "girls": 1,
        "total": 2
      },
      "st": {
        "boys": 111,
        "girls": 60,
        "total": 171
      }
    },
    "section4_adw": {
      "schools": 28,
      "boys": {
        "count": 1089,
        "classX_pct": 87.64,
        "classXII_pct": null
      },
      "girls": {
        "count": 1105,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 131,
        "classX_pct": 84,
        "classXII_pct": 0.36
      },
      "teachers": {
        "general": {
          "sanctioned": 3,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 81,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 0,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 47,
      "boys": {
        "count": 0.94,
        "classX_pct": 0.94,
        "classXII_pct": null
      },
      "girls": {
        "count": 0.94,
        "classX_pct": 0.97,
        "classXII_pct": null
      },
      "total": {
        "count": 0.94,
        "classX_pct": 0.65,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 281,
          "actual": 137,
          "vacant_pct": 144
        }
      }
    },
    "court_cases": {
      "pending": 23,
      "new_since_2026": 1,
      "more_than_1yr": 22,
      "contempt": 1,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": 37,
      "new": 21,
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 8,
      "disposed": 8,
      "pending": "no",
      "appeal1": 1,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": null,
      "villages_without": "1+1",
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "adw(school)": {
        "y20_30": 13,
        "y30_40": 2,
        "y40_plus": 3,
        "stability_cert": 0
      },
      "adw(hostel)": {
        "y20_30": 35,
        "y30_40": 0,
        "y40_plus": 0,
        "stability_cert": "YES"
      }
    },
    "mobile": {
      "no_mobile": 0
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Kanchipuram",
    "blocks": 5,
    "highConcBlocks": "Uthiramerur",
    "scstVillages40plus": null,
    "scHabitations": 274,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 734580,
        "pct": null,
        "remarks": null
      },
      "sc": {
        "count": 243348,
        "pct": 33.13,
        "remarks": null
      },
      "st": {
        "count": 10450,
        "pct": 4.29,
        "remarks": null
      },
      "total": {
        "count": 253798,
        "pct": 37.42,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 89.89,
        "female": 79.02,
        "total": 84.49
      },
      "sc": {
        "male": 84.2,
        "female": 70.44,
        "total": 77.31
      },
      "st": {
        "male": 78.22,
        "female": 61.66,
        "total": 69.91
      },
      "total": {
        "male": 81.21,
        "female": 66.05,
        "total": 73.61
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 6,
        "girls": 1,
        "total": 7
      },
      "sc": {
        "boys": 4,
        "girls": 1,
        "total": 5
      },
      "st": {
        "boys": 2,
        "girls": 0,
        "total": 2
      }
    },
    "section4_adw": {
      "schools": 32,
      "boys": {
        "count": 370,
        "classX_pct": 93.7,
        "classXII_pct": 92.4
      },
      "girls": {
        "count": 339,
        "classX_pct": 95.2,
        "classXII_pct": 94.4
      },
      "total": {
        "count": 709,
        "classX_pct": 94.45,
        "classXII_pct": 93.4
      },
      "teachers": {
        "general": {
          "sanctioned": 74,
          "actual": 68,
          "vacant_pct": 8.1
        },
        "sc": {
          "sanctioned": 84,
          "actual": 73,
          "vacant_pct": 10.71
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {
      "schools": 0,
      "boys": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "girls": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "total": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "court_cases": {
      "pending": 5,
      "new_since_2026": 5,
      "more_than_1yr": 1,
      "contempt": 2,
      "ca_not_filed": 3
    },
    "cm_cell": {
      "pending": 1,
      "new": 1,
      "rating_a": 0,
      "rating_b": 0,
      "rating_c": 0
    },
    "rti": {
      "received": 14,
      "disposed": 4,
      "pending": 10,
      "appeal1": 1,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 0,
      "more_1yr": 0,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": null,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouuseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": 0
    },
    "electricity": {
      "no_habitations": 0,
      "no_households": 0
    }
  },
  {
    "name": "Kanyakumari",
    "blocks": null,
    "highConcBlocks": null,
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 646441,
        "pct": null,
        "remarks": null
      },
      "sc": {
        "count": 26546,
        "pct": 4.1,
        "remarks": null
      },
      "st": {
        "count": 3893,
        "pct": 0.6,
        "remarks": null
      },
      "total": {
        "count": 676880,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 321154,
        "female": 325257,
        "total": 646441
      },
      "sc": {
        "male": 13227,
        "female": 13319,
        "total": 26546
      },
      "st": {
        "male": 1884,
        "female": 2009,
        "total": 3893
      },
      "total": {
        "male": 336265,
        "female": 340585,
        "total": 676880
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "sc": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 5,
      "boys": {
        "count": 194,
        "classX_pct": 100,
        "classXII_pct": 85.5
      },
      "girls": {
        "count": 183,
        "classX_pct": 100,
        "classXII_pct": 91
      },
      "total": {
        "count": 377,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 14,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 13,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 1,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 7,
      "boys": {
        "count": 325,
        "classX_pct": 100,
        "classXII_pct": 98
      },
      "girls": {
        "count": 361,
        "classX_pct": 98.3,
        "classXII_pct": 100
      },
      "total": {
        "count": 686,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 22,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 15,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 2,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 2,
      "new_since_2026": null,
      "more_than_1yr": 1,
      "contempt": null,
      "ca_not_filed": 1
    },
    "cm_cell": {
      "pending": 29,
      "new": 16,
      "rating_a": 3,
      "rating_b": 2,
      "rating_c": 3
    },
    "rti": {
      "received": 43,
      "disposed": 40,
      "pending": 3,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": 20,
      "villages_without": null,
      "common_no_discrimination": 6,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "adw hostel - 10": {
        "y20_30": 3,
        "y30_40": null,
        "y40_plus": 2,
        "stability_cert": "Letters has been sent to TAHDCO EE to ascertain stability"
      },
      "adw school - 5": {
        "y20_30": 2,
        "y30_40": 1,
        "y40_plus": 4,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Karur",
    "blocks": null,
    "highConcBlocks": "in Nos",
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 508441,
        "pct": 76.07,
        "remarks": "Nil"
      },
      "sc": {
        "count": 159718,
        "pct": 23.89,
        "remarks": "Nil"
      },
      "st": {
        "count": 602,
        "pct": 3.0,
        "remarks": "Nil"
      },
      "total": {
        "count": 668761,
        "pct": null,
        "remarks": "Nil"
      }
    },
    "literacy": {
      "general": {
        "male": null,
        "female": null,
        "total": null
      },
      "sc": {
        "male": null,
        "female": null,
        "total": null
      },
      "st": {
        "male": null,
        "female": null,
        "total": null
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 27,
      "boys": {
        "count": 261,
        "classX_pct": 88.69,
        "classXII_pct": 96.26
      },
      "girls": {
        "count": 220,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 481,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 114,
          "actual": 114,
          "vacant_pct": 9
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 1,
      "new_since_2026": 0,
      "more_than_1yr": 0,
      "contempt": 0,
      "ca_not_filed": 0
    },
    "cm_cell": {
      "pending": 7,
      "new": 62,
      "rating_a": 44,
      "rating_b": 11,
      "rating_c": "-------"
    },
    "rti": {
      "received": 33,
      "disposed": 25,
      "pending": 5,
      "appeal1": 3,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": "Nil",
      "more_1yr": "Nil",
      "more_3yr": "Nil",
      "more_5yr": "Nil"
    },
    "burial_grounds": {
      "total_scst": "Kulithalai",
      "villages_without": 45,
      "common_no_discrimination": null,
      "encroachments": 45
    },
    "transport": {
      "no_public_transport": "No. of connections provided for SC Habitations",
      "no_all_weather_roads": "Pending applications"
    },
    "drinking_water": {
      "connections_provided": "Nil",
      "pending": "Nil"
    },
    "buildings": {
      "school": {
        "y20_30": 60,
        "y30_40": 5,
        "y40_plus": 5,
        "stability_cert": 6
      },
      "hostel": {
        "y20_30": 2,
        "y30_40": 1,
        "y40_plus": 1,
        "stability_cert": 0
      }
    },
    "mobile": {
      "no_mobile": "Nil"
    },
    "electricity": {
      "no_habitations": "Nil",
      "no_households": "Nil"
    }
  },
  {
    "name": "Krishnagiri",
    "blocks": 10,
    "highConcBlocks": "uthangarai(St)thally",
    "scstVillages40plus": 11,
    "scHabitations": 407,
    "stHabitations": 66,
    "population": {
      "general": {
        "count": 1471187,
        "pct": 82.8,
        "remarks": null
      },
      "sc": {
        "count": 281985,
        "pct": 15.8,
        "remarks": null
      },
      "st": {
        "count": 23509,
        "pct": 1.32,
        "remarks": null
      },
      "total": {
        "count": 1776681,
        "pct": 4455,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 79.65,
        "female": 64.86,
        "total": 144.51
      },
      "sc": {
        "male": 75.85,
        "female": 60.89,
        "total": 136.74
      },
      "st": {
        "male": 68.53,
        "female": 49.35,
        "total": 117.88
      },
      "total": {
        "male": 224.03,
        "female": 175.1,
        "total": 399.13
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 1,
      "boys": {
        "count": 67,
        "classX_pct": 1,
        "classXII_pct": 0.91
      },
      "girls": {
        "count": 88,
        "classX_pct": 0.92,
        "classXII_pct": 0.82
      },
      "total": {
        "count": 155,
        "classX_pct": 0.95,
        "classXII_pct": 0.86
      },
      "teachers": {
        "general": {
          "sanctioned": 26,
          "actual": 17,
          "vacant_pct": 0.65
        },
        "sc": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 26,
      "new_since_2026": 2,
      "more_than_1yr": 20,
      "contempt": 2,
      "ca_not_filed": "Nil"
    },
    "cm_cell": {
      "pending": 4,
      "new": 1,
      "rating_a": 102,
      "rating_b": 35,
      "rating_c": 26
    },
    "rti": {
      "received": 39,
      "disposed": 39,
      "pending": "Nil",
      "appeal1": 3,
      "appeal_commission": "Nil"
    },
    "pending_files": {
      "total": "Nil",
      "more_1yr": "Nil",
      "more_3yr": "Nil",
      "more_5yr": "Nil"
    },
    "burial_grounds": {
      "total_scst": 2,
      "villages_without": "Nil",
      "common_no_discrimination": "Nil",
      "encroachments": "Nil"
    },
    "transport": {
      "no_public_transport": "Nil",
      "no_all_weather_roads": "Nil"
    },
    "drinking_water": {
      "connections_provided": 407,
      "pending": "Nil"
    },
    "buildings": {
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "Nil"
    },
    "electricity": {
      "no_habitations": "Nil",
      "no_households": "Nil"
    }
  },
  {
    "name": "Madurai",
    "blocks": 13,
    "highConcBlocks": "SC Population: Sedapatti Block - 28270 ST Population: Thirupparankundram Block - 1447",
    "scstVillages40plus": 49,
    "scHabitations": null,
    "stHabitations": 91106,
    "population": {
      "general": {
        "count": 1023091,
        "pct": 78.7,
        "remarks": null
      },
      "sc": {
        "count": 272494,
        "pct": 21,
        "remarks": null
      },
      "st": {
        "count": 4896,
        "pct": 30.0,
        "remarks": null
      },
      "total": {
        "count": 1300481,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.8972,
        "female": 0.7716,
        "total": 0.8345
      },
      "sc": {
        "male": null,
        "female": null,
        "total": null
      },
      "st": {
        "male": null,
        "female": null,
        "total": null
      },
      "total": {
        "male": 0.8972,
        "female": 0.7716,
        "total": 0.8345
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 1,
        "girls": 0,
        "total": 0
      },
      "sc": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "st": {
        "boys": 1,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 18,
      "boys": {
        "count": 776,
        "classX_pct": 0.88,
        "classXII_pct": 0.94
      },
      "girls": {
        "count": 642,
        "classX_pct": 0.98,
        "classXII_pct": 0.97
      },
      "total": {
        "count": 1418,
        "classX_pct": 0.93,
        "classXII_pct": 0.95
      },
      "teachers": {
        "general": {
          "sanctioned": 110,
          "actual": 29,
          "vacant_pct": 0.06
        },
        "sc": {
          "sanctioned": 74,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 0,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 28,
      "new_since_2026": 2,
      "more_than_1yr": 26,
      "contempt": null,
      "ca_not_filed": 2
    },
    "cm_cell": {
      "pending": 51,
      "new": 311,
      "rating_a": 12,
      "rating_b": null,
      "rating_c": 1
    },
    "rti": {
      "received": 53,
      "disposed": 18,
      "pending": 35,
      "appeal1": null,
      "appeal_commission": 7
    },
    "pending_files": {
      "total": "Nil",
      "more_1yr": "Nil",
      "more_3yr": "Nil",
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": 208,
      "villages_without": 6,
      "common_no_discrimination": 1,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": "Nil",
      "no_all_weather_roads": "Nil"
    },
    "drinking_water": {
      "connections_provided": "Nil",
      "pending": "Nil"
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "Nil"
    },
    "electricity": {
      "no_habitations": "Nil",
      "no_households": "Nil"
    }
  },
  {
    "name": "Mayiladuthurai",
    "blocks": 5,
    "highConcBlocks": "Mayiladuthurai",
    "scstVillages40plus": 115,
    "scHabitations": 241,
    "stHabitations": 48,
    "population": {
      "general": {
        "count": 467831,
        "pct": 63.06,
        "remarks": null
      },
      "sc": {
        "count": 272582,
        "pct": 36.76,
        "remarks": null
      },
      "st": {
        "count": 1375,
        "pct": 18.0,
        "remarks": null
      },
      "total": {
        "count": 741788,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 89.79,
        "female": 77.58,
        "total": null
      },
      "sc": {
        "male": 84.23,
        "female": 70.1,
        "total": null
      },
      "st": {
        "male": null,
        "female": null,
        "total": null
      },
      "total": {
        "male": 361503,
        "female": 326002,
        "total": 687505
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 0,
        "girls": 4,
        "total": 0
      },
      "sc": {
        "boys": 0,
        "girls": 4,
        "total": 0
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 35,
      "boys": {
        "count": 643,
        "classX_pct": 173,
        "classXII_pct": 93.02
      },
      "girls": {
        "count": 629,
        "classX_pct": 144,
        "classXII_pct": 94.59
      },
      "total": {
        "count": 1272,
        "classX_pct": 317,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 10,
          "actual": 112,
          "vacant_pct": 74
        },
        "sc": {
          "sanctioned": 64,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 0,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 0,
      "boys": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "girls": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "total": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "court_cases": {
      "pending": 3,
      "new_since_2026": 1,
      "more_than_1yr": 2,
      "contempt": 0,
      "ca_not_filed": 1
    },
    "cm_cell": {
      "pending": 9,
      "new": 42,
      "rating_a": 3,
      "rating_b": 2,
      "rating_c": 0
    },
    "rti": {
      "received": 25,
      "disposed": 24,
      "pending": 1,
      "appeal1": 0,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 0,
      "more_1yr": 0,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": 1074,
      "villages_without": "Nil",
      "common_no_discrimination": 4,
      "encroachments": "Nil"
    },
    "transport": {
      "no_public_transport": 0,
      "no_all_weather_roads": 1
    },
    "drinking_water": {
      "connections_provided": 1074,
      "pending": 0
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "Nil"
    },
    "electricity": {
      "no_habitations": "Nil",
      "no_households": "Nil"
    }
  },
  {
    "name": "Nagapattinam",
    "blocks": 6,
    "highConcBlocks": "Nagapattinam",
    "scstVillages40plus": 80,
    "scHabitations": 462,
    "stHabitations": 37,
    "population": {
      "general": {
        "count": 482703,
        "pct": 69.26,
        "remarks": null
      },
      "sc": {
        "count": 212760,
        "pct": 30.51,
        "remarks": null
      },
      "st": {
        "count": 1606,
        "pct": 23.0,
        "remarks": null
      },
      "total": {
        "count": 697069,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 100050,
        "female": 180300,
        "total": 280350
      },
      "sc": {
        "male": 87000,
        "female": 75200,
        "total": 162200
      },
      "st": {
        "male": 250,
        "female": 350,
        "total": 600
      },
      "total": {
        "male": 187300,
        "female": 255850,
        "total": 443150
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "sc": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 13,
      "boys": {
        "count": 193,
        "classX_pct": 100,
        "classXII_pct": 0
      },
      "girls": {
        "count": 195,
        "classX_pct": 90.47,
        "classXII_pct": 0
      },
      "total": {
        "count": 388,
        "classX_pct": 91,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 1,
          "actual": 1,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 13,
          "actual": 13,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {
      "schools": 0,
      "boys": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "girls": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "total": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "court_cases": {
      "pending": 0,
      "new_since_2026": 0,
      "more_than_1yr": 0,
      "contempt": 0,
      "ca_not_filed": 0
    },
    "cm_cell": {
      "pending": 0,
      "new": 3,
      "rating_a": 7,
      "rating_b": 7,
      "rating_c": 0
    },
    "rti": {
      "received": 0,
      "disposed": 0,
      "pending": 0,
      "appeal1": 0,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 0,
      "more_1yr": 0,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": 191,
      "villages_without": 0,
      "common_no_discrimination": 6,
      "encroachments": 0
    },
    "transport": {
      "no_public_transport": 0,
      "no_all_weather_roads": 0
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouuseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": 0
    },
    "electricity": {
      "no_habitations": 0,
      "no_households": 0
    }
  },
  {
    "name": "Namakkal",
    "blocks": 15,
    "highConcBlocks": "Erumaipatti, Elaichipalayam, Tiruchengode and Puduchatram",
    "scstVillages40plus": 41,
    "scHabitations": 800,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 1316211,
        "pct": 76.23,
        "remarks": null
      },
      "sc": {
        "count": 346873,
        "pct": 20.09,
        "remarks": null
      },
      "st": {
        "count": 63517,
        "pct": 3.68,
        "remarks": null
      },
      "total": {
        "count": 1726601,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.848,
        "female": 0.687,
        "total": 0.768
      },
      "sc": {
        "male": 0.7417,
        "female": 0.5776,
        "total": 0.66
      },
      "st": {
        "male": 0.603,
        "female": 0.449,
        "total": 0.527
      },
      "total": {
        "male": 0.8264,
        "female": 0.6657,
        "total": 0.7463
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 3,
        "girls": 1,
        "total": 4
      },
      "sc": {
        "boys": 3,
        "girls": 1,
        "total": 4
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 7,
      "boys": {
        "count": 321,
        "classX_pct": 0.83,
        "classXII_pct": 0.91
      },
      "girls": {
        "count": 286,
        "classX_pct": 0.98,
        "classXII_pct": 1
      },
      "total": {
        "count": 607,
        "classX_pct": 0.905,
        "classXII_pct": 0.955
      },
      "teachers": {
        "general": {
          "sanctioned": 13,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 17,
          "actual": 1,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 1,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 8,
      "boys": {
        "count": 932,
        "classX_pct": 94.3,
        "classXII_pct": 0.917
      },
      "girls": {
        "count": 831,
        "classX_pct": 94.6,
        "classXII_pct": 0.956
      },
      "total": {
        "count": 1763,
        "classX_pct": 94.45,
        "classXII_pct": 0.9365
      },
      "teachers": {
        "general": {
          "sanctioned": 48,
          "actual": 28,
          "vacant_pct": 0.417
        },
        "sc": {
          "sanctioned": 25,
          "actual": 21,
          "vacant_pct": 0.16
        },
        "st": {
          "sanctioned": 24,
          "actual": 17,
          "vacant_pct": 0.333
        }
      }
    },
    "court_cases": {
      "pending": 3,
      "new_since_2026": 3,
      "more_than_1yr": 0,
      "contempt": 0,
      "ca_not_filed": 0
    },
    "cm_cell": {
      "pending": 6,
      "new": 23,
      "rating_a": 0,
      "rating_b": 0,
      "rating_c": 0
    },
    "rti": {
      "received": 42,
      "disposed": 42,
      "pending": null,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": null,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "hostel": {
        "y20_30": 17,
        "y30_40": 0,
        "y40_plus": 5,
        "stability_cert": 4
      },
      "school": {
        "y20_30": 4,
        "y30_40": 1,
        "y40_plus": 3,
        "stability_cert": 0
      }
    },
    "mobile": {
      "no_mobile": 4
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Nilgiris",
    "blocks": 6,
    "highConcBlocks": "1.Gudalur 2.Pandalur",
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": 568,
    "population": {
      "general": {
        "count": 735000,
        "pct": 64.09,
        "remarks": null
      },
      "sc": {
        "count": 238014,
        "pct": 32.37,
        "remarks": null
      },
      "st": {
        "count": 26015,
        "pct": 3.54,
        "remarks": null
      },
      "total": {
        "count": 999029,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 91.72,
        "female": 78.98,
        "total": 85.2
      },
      "sc": {
        "male": 89.12,
        "female": 74.11,
        "total": 83.63
      },
      "st": {
        "male": 70.78,
        "female": 56.25,
        "total": 63.34
      },
      "total": {
        "male": 251.62,
        "female": 209.34,
        "total": 232.17
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 36,
        "girls": 21,
        "total": 57
      },
      "sc": {
        "boys": 3,
        "girls": 2,
        "total": 5
      },
      "st": {
        "boys": 33,
        "girls": 19,
        "total": 52
      }
    },
    "section4_adw": {
      "schools": 6,
      "boys": {
        "count": 68,
        "classX_pct": 6,
        "classXII_pct": null
      },
      "girls": {
        "count": 60,
        "classX_pct": 4,
        "classXII_pct": null
      },
      "total": {
        "count": 128,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 26,
          "actual": 0.62,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 0,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 29,
      "boys": {
        "count": 1087,
        "classX_pct": 80,
        "classXII_pct": 30
      },
      "girls": {
        "count": 1024,
        "classX_pct": 87,
        "classXII_pct": 41
      },
      "total": {
        "count": 2111,
        "classX_pct": 0.91,
        "classXII_pct": 0.96
      },
      "teachers": {
        "general": {
          "sanctioned": 132,
          "actual": 0.46,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 52,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 8,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 5,
      "new_since_2026": 0,
      "more_than_1yr": 5,
      "contempt": 0,
      "ca_not_filed": 0
    },
    "cm_cell": {
      "pending": 10,
      "new": 143,
      "rating_a": 1,
      "rating_b": 2,
      "rating_c": 4
    },
    "rti": {
      "received": 27,
      "disposed": 24,
      "pending": 3,
      "appeal1": "Nil",
      "appeal_commission": "Ni;"
    },
    "pending_files": {
      "total": 1,
      "more_1yr": 1,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": null,
      "villages_without": 2,
      "common_no_discrimination": 3,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": 15,
      "no_all_weather_roads": 5
    },
    "drinking_water": {
      "connections_provided": 129,
      "pending": 0
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": 2
    },
    "electricity": {
      "no_habitations": "Nil",
      "no_households": "Nil"
    }
  },
  {
    "name": "Perambalur",
    "blocks": 4,
    "highConcBlocks": "Veppur - 22 Veppanthattai - 18 Perambalur - 12 Alathur - 12",
    "scstVillages40plus": 64,
    "scHabitations": 107,
    "stHabitations": 14,
    "population": {
      "general": {
        "count": 565223,
        "pct": null,
        "remarks": null
      },
      "sc": {
        "count": 175289,
        "pct": 31.0,
        "remarks": "As per 2011 Census"
      },
      "st": {
        "count": 2584,
        "pct": 0.45,
        "remarks": "As per 2011 Census"
      },
      "total": {
        "count": 177873,
        "pct": 31.45,
        "remarks": "As per 2011 Census"
      }
    },
    "literacy": {
      "general": {
        "male": 208011,
        "female": 167812,
        "total": 375823
      },
      "sc": {
        "male": null,
        "female": null,
        "total": null
      },
      "st": {
        "male": null,
        "female": null,
        "total": null
      },
      "total": {
        "male": 208011,
        "female": 167812,
        "total": 375823
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 3,
        "girls": 4,
        "total": 7
      },
      "sc": {
        "boys": 3,
        "girls": 4,
        "total": 7
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": null,
      "boys": {
        "count": 740,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 701,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 1441,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 1,
      "boys": {
        "count": 40,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 22,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 62,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 11,
      "new_since_2026": 1,
      "more_than_1yr": 9,
      "contempt": 2,
      "ca_not_filed": 1
    },
    "cm_cell": {
      "pending": 4,
      "new": 4,
      "rating_a": 7,
      "rating_b": 4,
      "rating_c": 3
    },
    "rti": {
      "received": 43,
      "disposed": 35,
      "pending": 8,
      "appeal1": 0,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": 121,
      "villages_without": 121,
      "common_no_discrimination": 0,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": "All Villages have Transport facilities",
      "no_all_weather_roads": "All weather roads has been connectivity"
    },
    "drinking_water": {
      "connections_provided": "All Villages have drinking facilities",
      "pending": "NIL"
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouuseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "All Villages have telephone facilities"
    },
    "electricity": {
      "no_habitations": "All Villages have Electricity facilities",
      "no_households": "All households have Electricity facilities"
    }
  },
  {
    "name": "Pudukkottai",
    "blocks": 13,
    "highConcBlocks": "ANNAVASAL",
    "scstVillages40plus": 37,
    "scHabitations": 674,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 1088714,
        "pct": 81.18,
        "remarks": null
      },
      "sc": {
        "count": 251552,
        "pct": 18.76,
        "remarks": null
      },
      "st": {
        "count": 845,
        "pct": 6.0,
        "remarks": null
      },
      "total": {
        "count": 1341111,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.8556,
        "female": 0.69,
        "total": 0.7719
      },
      "sc": {
        "male": 0.8274,
        "female": 0.6538,
        "total": 0.7397
      },
      "st": {
        "male": 0.7398,
        "female": 0.6375,
        "total": 0.6881
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 1,
        "girls": 1,
        "total": 2
      },
      "sc": {
        "boys": 1,
        "girls": 1,
        "total": 2
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 13,
      "boys": {
        "count": 500,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 487,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 987,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 5,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 39,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 4,
      "new_since_2026": 3,
      "more_than_1yr": 4,
      "contempt": null,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": 9.18,
      "new": null,
      "rating_a": 77.78,
      "rating_b": 0,
      "rating_c": "22.2 (CLOSED)"
    },
    "rti": {
      "received": 20,
      "disposed": 20,
      "pending": null,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": 994,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": 49585,
      "pending": "3935(FHTC to be provided 26-27 proposal under process)"
    },
    "buildings": {
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Ramanathapuram",
    "blocks": 11,
    "highConcBlocks": "1.Paramakudi 2. Mudhukulaththur 3. kadaladi",
    "scstVillages40plus": 76,
    "scHabitations": 76,
    "stHabitations": 0,
    "population": {
      "general": {
        "count": 795161,
        "pct": 78.79,
        "remarks": null
      },
      "sc": {
        "count": 213583,
        "pct": 21.16,
        "remarks": null
      },
      "st": {
        "count": 526,
        "pct": 0.05,
        "remarks": null
      },
      "total": {
        "count": 1009270,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.8781,
        "female": 0.7352,
        "total": 0.8072
      },
      "sc": {
        "male": 0.8194,
        "female": 0.6496,
        "total": 0.7347
      },
      "st": {
        "male": 0.04,
        "female": 0.02,
        "total": 0.03
      },
      "total": {
        "male": 0.5659,
        "female": 0.4616,
        "total": 0.5141
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "sc": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 0,
      "boys": {
        "count": 302,
        "classX_pct": 0.98,
        "classXII_pct": 0
      },
      "girls": {
        "count": 258,
        "classX_pct": 1,
        "classXII_pct": 0
      },
      "total": {
        "count": 560,
        "classX_pct": 0.98,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 3,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 32,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {
      "schools": 0,
      "boys": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "girls": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "total": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "court_cases": {
      "pending": 12,
      "new_since_2026": 4,
      "more_than_1yr": 8,
      "contempt": 0,
      "ca_not_filed": 1
    },
    "cm_cell": {
      "pending": 0,
      "new": 0,
      "rating_a": "Rating A",
      "rating_b": "Rating B",
      "rating_c": null
    },
    "rti": {
      "received": 43,
      "disposed": 41,
      "pending": 2,
      "appeal1": 2,
      "appeal_commission": "No"
    },
    "pending_files": {
      "total": 2,
      "more_1yr": 2,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": 369,
      "villages_without": 7,
      "common_no_discrimination": 7,
      "encroachments": 0
    },
    "transport": {
      "no_public_transport": 0,
      "no_all_weather_roads": 0
    },
    "drinking_water": {
      "connections_provided": 76,
      "pending": 0
    },
    "buildings": {
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": 0
    },
    "electricity": {
      "no_habitations": 0,
      "no_households": 0
    }
  },
  {
    "name": "Ranipettai",
    "blocks": 7,
    "highConcBlocks": "Kaveripakkam",
    "scstVillages40plus": 25,
    "scHabitations": 1313,
    "stHabitations": 227,
    "population": {
      "general": {
        "count": 630715,
        "pct": 73.39,
        "remarks": null
      },
      "sc": {
        "count": 219017,
        "pct": 25.48,
        "remarks": null
      },
      "st": {
        "count": 9695,
        "pct": 1.13,
        "remarks": null
      },
      "total": {
        "count": 859427,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 75.89,
        "female": 80.02,
        "total": 82.49
      },
      "sc": {
        "male": 80.25,
        "female": 87.44,
        "total": 80.31
      },
      "st": {
        "male": 58.22,
        "female": 52.66,
        "total": 51.91
      },
      "total": {
        "male": 79.21,
        "female": 70.05,
        "total": 73.61
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "sc": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 7,
      "boys": {
        "count": 168,
        "classX_pct": 0.85,
        "classXII_pct": 0.85
      },
      "girls": {
        "count": 210,
        "classX_pct": 0.9,
        "classXII_pct": 0.9
      },
      "total": {
        "count": 145,
        "classX_pct": 97,
        "classXII_pct": 0.82
      },
      "teachers": {
        "general": {
          "sanctioned": 5,
          "actual": 5,
          "vacant_pct": 1
        },
        "sc": {
          "sanctioned": 140,
          "actual": 92,
          "vacant_pct": 0.81
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {
      "schools": 0,
      "boys": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "girls": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "total": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "court_cases": {
      "pending": 21,
      "new_since_2026": 0,
      "more_than_1yr": 21,
      "contempt": 1,
      "ca_not_filed": 0
    },
    "cm_cell": {
      "pending": 0,
      "new": 0,
      "rating_a": 0,
      "rating_b": 0,
      "rating_c": 0
    },
    "rti": {
      "received": 4,
      "disposed": 3,
      "pending": 1,
      "appeal1": 1,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 1,
      "more_1yr": 1,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": 52,
      "villages_without": 0,
      "common_no_discrimination": 0,
      "encroachments": 0
    },
    "transport": {
      "no_public_transport": 0,
      "no_all_weather_roads": 0
    },
    "drinking_water": {
      "connections_provided": 0,
      "pending": 0
    },
    "buildings": {
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": 0
    },
    "electricity": {
      "no_habitations": 0,
      "no_households": 0
    }
  },
  {
    "name": "Salem",
    "blocks": 20,
    "highConcBlocks": null,
    "scstVillages40plus": 49,
    "scHabitations": 0,
    "stHabitations": 418,
    "population": {
      "general": {
        "count": 2782175,
        "pct": 80,
        "remarks": null
      },
      "sc": {
        "count": 580512,
        "pct": 16.57,
        "remarks": "2011 - Census"
      },
      "st": {
        "count": 119369,
        "pct": 3.43,
        "remarks": "2011 - Census"
      },
      "total": {
        "count": 1,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": null,
        "female": null,
        "total": null
      },
      "sc": {
        "male": 55.29,
        "female": 44.7,
        "total": null
      },
      "st": {
        "male": 59,
        "female": 41,
        "total": null
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 40,
        "girls": 21,
        "total": 61
      },
      "sc": {
        "boys": 1,
        "girls": 1,
        "total": 2
      },
      "st": {
        "boys": 39,
        "girls": 20,
        "total": 59
      }
    },
    "section4_adw": {
      "schools": 13,
      "boys": {
        "count": 614,
        "classX_pct": 0.82,
        "classXII_pct": 0.975
      },
      "girls": {
        "count": 504,
        "classX_pct": 0.91,
        "classXII_pct": 0.98
      },
      "total": {
        "count": 78,
        "classX_pct": 65,
        "classXII_pct": 0.83
      },
      "teachers": {
        "general": {
          "sanctioned": 78,
          "actual": 19,
          "vacant_pct": 13
        },
        "sc": {
          "sanctioned": 0,
          "actual": 46,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {
      "schools": 63,
      "boys": {
        "count": 586,
        "classX_pct": 99,
        "classXII_pct": 0.96
      },
      "girls": {
        "count": 571,
        "classX_pct": 0.99,
        "classXII_pct": 0.99
      },
      "total": {
        "count": 1157,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 276,
          "actual": 173,
          "vacant_pct": 0.63
        }
      }
    },
    "court_cases": {
      "pending": null,
      "new_since_2026": null,
      "more_than_1yr": null,
      "contempt": null,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": 75,
      "new": 74,
      "rating_a": "NIL",
      "rating_b": "NIL",
      "rating_c": "NIL"
    },
    "rti": {
      "received": 62,
      "disposed": 62,
      "pending": 0,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": "NIL",
      "more_1yr": "NIL",
      "more_3yr": "NIL",
      "more_5yr": "NIL"
    },
    "burial_grounds": {
      "total_scst": null,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": "1) JARUGUMALAI (kURALNATHAM - 2 VILLAGES MELUR AND KEELUR 2) PALAMALAI - 18 HABITATIONS",
      "no_all_weather_roads": "PALAMALAI"
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "adw school -13": {
        "y20_30": 4,
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": "A certificate stating that 2 buildings lack structural stability has been obtained from the TAHDCO engineer."
      },
      "social justice hostel-42": {
        "y20_30": 13,
        "y30_40": 2,
        "y40_plus": 7,
        "stability_cert": "A certificate stating that 7 buildings lack structural stability has been obtained from the TAHDCO engineer."
      }
    },
    "mobile": {
      "no_mobile": 105
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Sivagangai",
    "blocks": null,
    "highConcBlocks": null,
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": null,
        "pct": null,
        "remarks": null
      },
      "sc": {
        "count": 227867,
        "pct": 17.01,
        "remarks": null
      },
      "st": {
        "count": 854,
        "pct": 0.06,
        "remarks": null
      },
      "total": {
        "count": 1339101,
        "pct": 82.93,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.8792,
        "female": 0.7185,
        "total": 0.8
      },
      "sc": {
        "male": 0.8322,
        "female": 0.6537,
        "total": 0.743
      },
      "st": {
        "male": null,
        "female": null,
        "total": null
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 3,
      "boys": {
        "count": 211,
        "classX_pct": 100,
        "classXII_pct": 100
      },
      "girls": {
        "count": 176,
        "classX_pct": 100,
        "classXII_pct": 100
      },
      "total": {
        "count": 387,
        "classX_pct": 100,
        "classXII_pct": 100
      },
      "teachers": {
        "general": {
          "sanctioned": 27,
          "actual": 20,
          "vacant_pct": 7
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 9,
      "new_since_2026": 8,
      "more_than_1yr": 1,
      "contempt": null,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": 83,
      "new": 23,
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 4,
      "disposed": 3,
      "pending": 1,
      "appeal1": 1,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": "Above 300",
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": 4
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": 37347,
      "pending": 10786
    },
    "buildings": {
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Tenkasi",
    "blocks": 10,
    "highConcBlocks": "Vasudevanallur",
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": 3,
    "population": {
      "general": {
        "count": 1440795,
        "pct": 83.16,
        "remarks": null
      },
      "sc": {
        "count": 288295,
        "pct": 16.2,
        "remarks": null
      },
      "st": {
        "count": 3563,
        "pct": 64.0,
        "remarks": null
      },
      "total": {
        "count": 1732653,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.8924,
        "female": 0.7598,
        "total": 0.825
      },
      "sc": {
        "male": 0.8375,
        "female": 0.6723,
        "total": 0.753
      },
      "st": {
        "male": 0.8587,
        "female": 0.7842,
        "total": 0.821
      },
      "total": {
        "male": 526131,
        "female": 424795,
        "total": 960926
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "sc": {
        "boys": 0,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": 0,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 1,
      "boys": {
        "count": 60,
        "classX_pct": 100,
        "classXII_pct": 0
      },
      "girls": {
        "count": 47,
        "classX_pct": 100,
        "classXII_pct": 0
      },
      "total": {
        "count": 107,
        "classX_pct": 100,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 3,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 4,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 1,
      "boys": {
        "count": 4,
        "classX_pct": 0,
        "classXII_pct": null
      },
      "girls": {
        "count": 5,
        "classX_pct": 0,
        "classXII_pct": null
      },
      "total": {
        "count": 9,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 1,
          "actual": 50,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 11,
      "new_since_2026": 1,
      "more_than_1yr": null,
      "contempt": null,
      "ca_not_filed": 1
    },
    "cm_cell": {
      "pending": 2,
      "new": 2,
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 20,
      "disposed": 16,
      "pending": 4,
      "appeal1": 4,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": 5,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": "nil",
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "yes"
    },
    "electricity": {
      "no_habitations": "yes",
      "no_households": null
    }
  },
  {
    "name": "Thanjavur",
    "blocks": 14,
    "highConcBlocks": null,
    "scstVillages40plus": 86,
    "scHabitations": 555,
    "stHabitations": 107,
    "population": {
      "general": {
        "count": 1790998,
        "pct": null,
        "remarks": "NIL | NIL"
      },
      "sc": {
        "count": 455062,
        "pct": 18.91,
        "remarks": "NIL | NIL"
      },
      "st": {
        "count": 3561,
        "pct": 0.15,
        "remarks": "NIL | NIL"
      },
      "total": {
        "count": 2249621,
        "pct": 19.06,
        "remarks": "NIL | NIL"
      }
    },
    "literacy": {
      "general": {
        "male": 0.89,
        "female": 0.765,
        "total": null
      },
      "sc": {
        "male": null,
        "female": null,
        "total": null
      },
      "st": {
        "male": null,
        "female": null,
        "total": null
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 10,
        "girls": 5,
        "total": 15
      },
      "sc": {
        "boys": 10,
        "girls": 5,
        "total": 15
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 100,
      "boys": {
        "count": 2022,
        "classX_pct": 0.9675,
        "classXII_pct": 0.97
      },
      "girls": {
        "count": 1913,
        "classX_pct": 0.9829,
        "classXII_pct": 1
      },
      "total": {
        "count": 3915,
        "classX_pct": 0.9752,
        "classXII_pct": 0.9803
      },
      "teachers": {
        "general": {
          "sanctioned": 342,
          "actual": 246,
          "vacant_pct": 0.2807
        },
        "sc": {
          "sanctioned": 0,
          "actual": 148,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 3,
      "new_since_2026": 1,
      "more_than_1yr": 2,
      "contempt": "NIL",
      "ca_not_filed": 1
    },
    "cm_cell": {
      "pending": "NIL",
      "new": "NIL",
      "rating_a": 37,
      "rating_b": 46,
      "rating_c": 18
    },
    "rti": {
      "received": 34,
      "disposed": 21,
      "pending": 13,
      "appeal1": "NIL",
      "appeal_commission": "NIL"
    },
    "pending_files": {
      "total": "NIL",
      "more_1yr": "NIL",
      "more_3yr": "NIL",
      "more_5yr": "NIL"
    },
    "burial_grounds": {
      "total_scst": 720,
      "villages_without": 2,
      "common_no_discrimination": 6,
      "encroachments": "NIL"
    },
    "transport": {
      "no_public_transport": "NIL",
      "no_all_weather_roads": "NIL"
    },
    "drinking_water": {
      "connections_provided": "NIL",
      "pending": "NIL"
    },
    "buildings": {
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "NIL"
    },
    "electricity": {
      "no_habitations": "NIL",
      "no_households": "NIL"
    }
  },
  {
    "name": "Theni",
    "blocks": null,
    "highConcBlocks": null,
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 575394,
        "pct": 74.8,
        "remarks": "Nil"
      },
      "sc": {
        "count": 143589,
        "pct": 24.96,
        "remarks": "Nil"
      },
      "st": {
        "count": 1377,
        "pct": 24.0,
        "remarks": null
      },
      "total": {
        "count": null,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 625683,
        "female": 620216,
        "total": 1245899
      },
      "sc": {
        "male": 128800,
        "female": 129400,
        "total": 258200
      },
      "st": {
        "male": 920,
        "female": 915,
        "total": 1835
      },
      "total": {
        "male": 755403,
        "female": 750531,
        "total": 1505934
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 9,
      "boys": {
        "count": 411,
        "classX_pct": 0.88,
        "classXII_pct": 0.86
      },
      "girls": {
        "count": 373,
        "classX_pct": 0.97,
        "classXII_pct": 0.97
      },
      "total": {
        "count": 784,
        "classX_pct": 0.925,
        "classXII_pct": 0.905
      },
      "teachers": {
        "general": {
          "sanctioned": 13,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 35,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 2,
      "boys": {
        "count": 8,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 10,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 18,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 4,
          "actual": 4,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": "EP - 6 SLP - 1 TOTAL - 7",
      "new_since_2026": null,
      "more_than_1yr": 7,
      "contempt": null,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": "Nil",
      "new": "Total - 6 Accepted - 4 Rejected - 2",
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 40,
      "disposed": 38,
      "pending": 2,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": null,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": "01-",
      "no_all_weather_roads": 2
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "total-37 hostels": {
        "y20_30": 19,
        "y30_40": 3,
        "y40_plus": 2,
        "stability_cert": 1
      },
      "total - 09 adw schools": {
        "y20_30": 1,
        "y30_40": 0,
        "y40_plus": 3,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": 3
    },
    "electricity": {
      "no_habitations": 1,
      "no_households": null
    }
  },
  {
    "name": "Thiruchirapalli",
    "blocks": 14,
    "highConcBlocks": "Lalgudi, Uppliyapuram Thuraiyur",
    "scstVillages40plus": 56,
    "scHabitations": 158,
    "stHabitations": 71,
    "population": {
      "general": {
        "count": 2722290,
        "pct": null,
        "remarks": "_"
      },
      "sc": {
        "count": 466561,
        "pct": null,
        "remarks": "_"
      },
      "st": {
        "count": 18357,
        "pct": 0.67,
        "remarks": null
      },
      "total": {
        "count": 3207208,
        "pct": 0.67,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.8972,
        "female": 0.7687,
        "total": 0.8323
      },
      "sc": {
        "male": 0.8651,
        "female": 0.707,
        "total": 0.7849
      },
      "st": {
        "male": 0.8471,
        "female": 0.724,
        "total": 0.754
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 7,
        "girls": 3,
        "total": 10
      },
      "sc": {
        "boys": 7,
        "girls": 3,
        "total": 10
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 99,
      "boys": {
        "count": 3098,
        "classX_pct": 0.95,
        "classXII_pct": 0.91
      },
      "girls": {
        "count": 3218,
        "classX_pct": 0.97,
        "classXII_pct": 0.98
      },
      "total": {
        "count": 6316,
        "classX_pct": 0.96,
        "classXII_pct": 0.95
      },
      "teachers": {
        "general": {
          "sanctioned": 605,
          "actual": 101,
          "vacant_pct": 0.24
        },
        "sc": {
          "sanctioned": 310,
          "actual": 0.74,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 9,
          "actual": 0.02,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 27,
      "boys": {
        "count": 524,
        "classX_pct": 1,
        "classXII_pct": 1
      },
      "girls": {
        "count": 480,
        "classX_pct": 1,
        "classXII_pct": 1
      },
      "total": {
        "count": 1004,
        "classX_pct": 1,
        "classXII_pct": 1
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 43,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 12,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 22,
      "new_since_2026": 1,
      "more_than_1yr": 20,
      "contempt": 1,
      "ca_not_filed": "19932/2025"
    },
    "cm_cell": {
      "pending": 2,
      "new": 9,
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 44,
      "disposed": 43,
      "pending": 1,
      "appeal1": 6,
      "appeal_commission": "_"
    },
    "pending_files": {
      "total": 66,
      "more_1yr": "_",
      "more_3yr": 61,
      "more_5yr": "_"
    },
    "burial_grounds": {
      "total_scst": 706,
      "villages_without": 1,
      "common_no_discrimination": 3,
      "encroachments": 8
    },
    "transport": {
      "no_public_transport": "Thenpadi, Periyapazhamalai, Lakshmananpuram & Poolangudi",
      "no_all_weather_roads": "Nil"
    },
    "drinking_water": {
      "connections_provided": 28939,
      "pending": "Nil"
    },
    "buildings": {
      "a) school": {
        "y20_30": 60,
        "y30_40": 17,
        "y40_plus": 22,
        "stability_cert": 2
      },
      "b) hostel": {
        "y20_30": 9,
        "y30_40": 2,
        "y40_plus": "_",
        "stability_cert": 2
      }
    },
    "mobile": {
      "no_mobile": 5
    },
    "electricity": {
      "no_habitations": 1,
      "no_households": 26
    }
  },
  {
    "name": "Thiruvallur",
    "blocks": 14,
    "highConcBlocks": "MINJUR",
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 2859215,
        "pct": 76.69,
        "remarks": null
      },
      "sc": {
        "count": 821646,
        "pct": 22.04,
        "remarks": null
      },
      "st": {
        "count": 47243,
        "pct": 1.27,
        "remarks": null
      },
      "total": {
        "count": 3728104,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.8969,
        "female": 0.7832,
        "total": 0.8403
      },
      "sc": {
        "male": 0.8538,
        "female": 0.7136,
        "total": 0.7834
      },
      "st": {
        "male": 0.5976,
        "female": 0.4816,
        "total": 0.5396
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 6,
      "boys": {
        "count": 2007,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 2124,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 4131,
        "classX_pct": null,
        "classXII_pct": null
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 3,
      "new_since_2026": null,
      "more_than_1yr": 3,
      "contempt": null,
      "ca_not_filed": 1
    },
    "cm_cell": {
      "pending": 4,
      "new": 2,
      "rating_a": 0,
      "rating_b": 0,
      "rating_c": 0
    },
    "rti": {
      "received": 20,
      "disposed": 15,
      "pending": 5,
      "appeal1": 5,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 1,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": 1
    },
    "burial_grounds": {
      "total_scst": 1,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": 2234,
      "pending": null
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Thiruvannamalai",
    "blocks": 18,
    "highConcBlocks": "Jawadhu hills, Thandarampattu-ST Chengam-SC",
    "scstVillages40plus": null,
    "scHabitations": 1239,
    "stHabitations": 545,
    "population": {
      "general": {
        "count": 1808433,
        "pct": 73.37,
        "remarks": null
      },
      "sc": {
        "count": 565424,
        "pct": 22.94,
        "remarks": null
      },
      "st": {
        "count": 91018,
        "pct": 3.69,
        "remarks": null
      },
      "total": {
        "count": 2464875,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 83.11,
        "female": 65.32,
        "total": null
      },
      "sc": {
        "male": 0.7984,
        "female": 0.6303,
        "total": 0.7141
      },
      "st": {
        "male": 0.5602,
        "female": 0.3753,
        "total": 0.4681
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "st": {
        "boys": 44,
        "girls": 32,
        "total": 76
      }
    },
    "section4_adw": {
      "schools": 60,
      "boys": {
        "count": 1392,
        "classX_pct": 44,
        "classXII_pct": null
      },
      "girls": {
        "count": 1277,
        "classX_pct": 58,
        "classXII_pct": null
      },
      "total": {
        "count": 2669,
        "classX_pct": 108,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 5,
          "actual": 4,
          "vacant_pct": 1
        },
        "sc": {
          "sanctioned": 210,
          "actual": 140,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 1,
          "actual": 1,
          "vacant_pct": 70
        }
      }
    },
    "section4a_tw": {
      "schools": 32,
      "boys": {
        "count": 1551,
        "classX_pct": 1,
        "classXII_pct": 1
      },
      "girls": {
        "count": 1161,
        "classX_pct": 0.987,
        "classXII_pct": 1
      },
      "total": {
        "count": 70,
        "classX_pct": 70,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 19,
          "actual": 19,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 48,
          "actual": 48,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 3,
          "actual": 3,
          "vacant_pct": 0
        }
      }
    },
    "court_cases": {
      "pending": "DADW-7 TW-1",
      "new_since_2026": "DADW-1 TW-0",
      "more_than_1yr": "DADW-6 TW-1",
      "contempt": null,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": "DADW-45 TW-4",
      "new": "DADW-45 TW-4",
      "rating_a": "DADW-3 TW-0",
      "rating_b": "DADW-6 TW-0",
      "rating_c": "DADW-3 TW-0"
    },
    "rti": {
      "received": "DADW-20 TW-6",
      "disposed": "DADW-20 TW-6",
      "pending": null,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": "DADW -1 TW-0",
      "more_1yr": "DADW - yes",
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": "DADW-982 TW-0",
      "villages_without": 100,
      "common_no_discrimination": 14,
      "encroachments": 8
    },
    "transport": {
      "no_public_transport": "NIL",
      "no_all_weather_roads": "NIL"
    },
    "drinking_water": {
      "connections_provided": "DADW-1219",
      "pending": 0
    },
    "buildings": {
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "DADW-0 TW-200"
    },
    "electricity": {
      "no_habitations": "DADW-0 TW-0",
      "no_households": "TW-14"
    }
  },
  {
    "name": "Thiruvarur",
    "blocks": null,
    "highConcBlocks": null,
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": null,
        "pct": null,
        "remarks": null
      },
      "sc": {
        "count": 1,
        "pct": 306,
        "remarks": null
      },
      "st": {
        "count": 1,
        "pct": 0,
        "remarks": null
      },
      "total": {
        "count": 2,
        "pct": 306,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": null,
        "female": null,
        "total": null
      },
      "sc": {
        "male": 0.831,
        "female": 0.687,
        "total": 0.759
      },
      "st": {
        "male": 0.665,
        "female": 0.504,
        "total": 0.582
      },
      "total": {
        "male": 149.6,
        "female": 119.1,
        "total": 1.341
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 30,
      "boys": {
        "count": 630,
        "classX_pct": 0.8,
        "classXII_pct": 0.4489
      },
      "girls": {
        "count": 649,
        "classX_pct": 0.875,
        "classXII_pct": 0.6562
      },
      "total": {
        "count": 1279,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 114,
          "actual": 81,
          "vacant_pct": 0.41
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 3,
      "new_since_2026": 0,
      "more_than_1yr": 3,
      "contempt": "Nil",
      "ca_not_filed": 1
    },
    "cm_cell": {
      "pending": 52,
      "new": 122,
      "rating_a": 2,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 26,
      "disposed": 17,
      "pending": 9,
      "appeal1": "Nil",
      "appeal_commission": "Nil"
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": 516,
      "villages_without": null,
      "common_no_discrimination": 28,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouuseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Thoothukudi",
    "blocks": null,
    "highConcBlocks": null,
    "scstVillages40plus": null,
    "scHabitations": 488,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 1397370,
        "pct": 79.84,
        "remarks": null
      },
      "sc": {
        "count": 347895,
        "pct": 19.88,
        "remarks": null
      },
      "st": {
        "count": 4911,
        "pct": 0.28,
        "remarks": null
      },
      "total": {
        "count": 1750176,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.9113,
        "female": 0.8133,
        "total": null
      },
      "sc": {
        "male": 0.8779,
        "female": 0.7554,
        "total": null
      },
      "st": {
        "male": 0.7734,
        "female": 0.6701,
        "total": null
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 13,
      "boys": {
        "count": 236,
        "classX_pct": 11,
        "classXII_pct": null
      },
      "girls": {
        "count": 204,
        "classX_pct": 7,
        "classXII_pct": null
      },
      "total": {
        "count": 440,
        "classX_pct": 18,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 4,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 40,
          "actual": 29,
          "vacant_pct": 0.275
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {
      "schools": null,
      "boys": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": null,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 12,
      "new_since_2026": 12,
      "more_than_1yr": 6,
      "contempt": 6,
      "ca_not_filed": "Nil"
    },
    "cm_cell": {
      "pending": null,
      "new": 32,
      "rating_a": 2,
      "rating_b": "Nil",
      "rating_c": "Nil"
    },
    "rti": {
      "received": null,
      "disposed": 19,
      "pending": 15,
      "appeal1": 4,
      "appeal_commission": 2
    },
    "pending_files": {
      "total": null,
      "more_1yr": "NIL",
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": null,
      "villages_without": 322,
      "common_no_discrimination": "Nil",
      "encroachments": 75
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {},
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Tirunelveli",
    "blocks": null,
    "highConcBlocks": null,
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 550569,
        "pct": 33490,
        "remarks": null
      },
      "sc": {
        "count": 141932,
        "pct": 24410,
        "remarks": null
      },
      "st": {
        "count": 2933,
        "pct": 1250,
        "remarks": null
      },
      "total": {
        "count": 695434,
        "pct": 59150,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 233738,
        "female": 172719,
        "total": 406457
      },
      "sc": {
        "male": 47700,
        "female": 40227,
        "total": 87927
      },
      "st": {
        "male": 1018,
        "female": 845,
        "total": 1863
      },
      "total": {
        "male": 282456,
        "female": 213791,
        "total": 496247
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "sc": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 16,
      "boys": {
        "count": 506,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 422,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 928,
        "classX_pct": null,
        "classXII_pct": null
      }
    },
    "section4a_tw": {
      "schools": 2,
      "boys": {
        "count": 59,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 37,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 8,
        "classX_pct": 6,
        "classXII_pct": 2
      }
    },
    "court_cases": {
      "pending": 15,
      "new_since_2026": "_",
      "more_than_1yr": 14,
      "contempt": "_",
      "ca_not_filed": "_"
    },
    "cm_cell": {
      "pending": 14,
      "new": 42,
      "rating_a": 10,
      "rating_b": "_",
      "rating_c": "_"
    },
    "rti": {
      "received": 65,
      "disposed": 61,
      "pending": 4,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": 0,
      "more_1yr": 0,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": 138,
      "villages_without": 0,
      "common_no_discrimination": "_",
      "encroachments": "_"
    },
    "transport": {
      "no_public_transport": "NIL",
      "no_all_weather_roads": "NIL"
    },
    "drinking_water": {
      "connections_provided": 392,
      "pending": 0
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouuseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "5 (ST Habitation)"
    },
    "electricity": {
      "no_habitations": 0,
      "no_households": 0
    }
  },
  {
    "name": "Tirupattur",
    "blocks": 6,
    "highConcBlocks": "Madhanur - 73370 (Sc) Tirupathur - 21677 (ST)",
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": null,
    "population": {
      "general": {
        "count": 905687,
        "pct": 75.0,
        "remarks": null
      },
      "sc": {
        "count": 235806,
        "pct": 20.0,
        "remarks": null
      },
      "st": {
        "count": 35298,
        "pct": 5.0,
        "remarks": null
      },
      "total": {
        "count": 1176791,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.865,
        "female": 0.7195,
        "total": 0.704
      },
      "sc": {
        "male": 0.86,
        "female": 0.7254,
        "total": 0.7914
      },
      "st": {
        "male": 0.6142,
        "female": 0.3704,
        "total": 0.4949
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "sc": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 13,
      "boys": {
        "count": 123,
        "classX_pct": 0.8,
        "classXII_pct": 0.9
      },
      "girls": {
        "count": 85,
        "classX_pct": 0.93,
        "classXII_pct": 0.9
      },
      "total": {
        "count": 208,
        "classX_pct": 0.86,
        "classXII_pct": 0.9
      },
      "teachers": {
        "general": {
          "sanctioned": 75,
          "actual": 64,
          "vacant_pct": 0.85
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 7,
      "boys": {
        "count": 50,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 40,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 90,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 12,
          "actual": 2,
          "vacant_pct": 0.83
        }
      }
    },
    "court_cases": {
      "pending": "ADW-6 TW-4",
      "new_since_2026": "ADW-0 TW-0",
      "more_than_1yr": "ADW-5 TW-3",
      "contempt": "ADW-1 TW-1",
      "ca_not_filed": 0
    },
    "cm_cell": {
      "pending": "ADW - 1 TW-1",
      "new": "ADW-1 TW-1",
      "rating_a": 0,
      "rating_b": 0,
      "rating_c": 0
    },
    "rti": {
      "received": "ADW-33 TW-15",
      "disposed": "ADW-26 TW-15",
      "pending": "ADW-7 TW-0",
      "appeal1": "ADW-1 TW-0",
      "appeal_commission": "ADW-0 TW-0"
    },
    "pending_files": {
      "total": "TW-1",
      "more_1yr": "TW-1",
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": 79,
      "villages_without": 7,
      "common_no_discrimination": 3,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": "TW-14",
      "no_all_weather_roads": "TW-9 (Demaged)"
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "hostel": {
        "y20_30": "ADW - 8 TW-0",
        "y30_40": "ADW - 3 TW-0",
        "y40_plus": "ADW - 2 TW-0",
        "stability_cert": null
      },
      "school": {
        "y20_30": "ADW - 13 TW-7",
        "y30_40": "ADW - 2 TW-2",
        "y40_plus": "ADW - 0 TW-1",
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "TW-4"
    },
    "electricity": {
      "no_habitations": "TW- Nill",
      "no_households": "TW- Nill"
    }
  },
  {
    "name": "Tiruppur",
    "blocks": null,
    "highConcBlocks": "Udumalpet",
    "scstVillages40plus": null,
    "scHabitations": 38,
    "stHabitations": 19,
    "population": {
      "general": {
        "count": 126709,
        "pct": null,
        "remarks": null
      },
      "sc": {
        "count": 39776,
        "pct": null,
        "remarks": null
      },
      "st": {
        "count": 1296,
        "pct": null,
        "remarks": null
      },
      "total": {
        "count": 167781,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 85.49,
        "female": 71.82,
        "total": 76.78
      },
      "sc": {
        "male": 68.1,
        "female": 54.93,
        "total": 61.46
      },
      "st": {
        "male": null,
        "female": null,
        "total": null
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "sc": {
        "boys": null,
        "girls": null,
        "total": null
      },
      "st": {
        "boys": null,
        "girls": null,
        "total": null
      }
    },
    "section4_adw": {
      "schools": 9,
      "boys": {
        "count": 311,
        "classX_pct": 1,
        "classXII_pct": null
      },
      "girls": {
        "count": 337,
        "classX_pct": 0.94,
        "classXII_pct": null
      },
      "total": {
        "count": 648,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 35,
          "actual": 5,
          "vacant_pct": 0.15
        },
        "sc": {
          "sanctioned": 25,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 5,
      "boys": {
        "count": 82,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 60,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 142,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": 10,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 9,
          "actual": 0.1,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 5,
      "new_since_2026": 1,
      "more_than_1yr": 4,
      "contempt": null,
      "ca_not_filed": null
    },
    "cm_cell": {
      "pending": 3,
      "new": 3,
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 47,
      "disposed": 47,
      "pending": null,
      "appeal1": null,
      "appeal_commission": null
    },
    "pending_files": {
      "total": null,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": 41,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": "NIL"
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": "NIL"
    },
    "buildings": {
      "hostels": {
        "y20_30": 5,
        "y30_40": 2,
        "y40_plus": 4,
        "stability_cert": 5
      },
      "schools": {
        "y20_30": 3,
        "y30_40": 0,
        "y40_plus": 3,
        "stability_cert": 1
      }
    },
    "mobile": {
      "no_mobile": 16
    },
    "electricity": {
      "no_habitations": 14,
      "no_households": 991
    }
  },
  {
    "name": "Vellore",
    "blocks": 7,
    "highConcBlocks": "Gudiyatham",
    "scstVillages40plus": 69,
    "scHabitations": 241,
    "stHabitations": 124,
    "population": {
      "general": {
        "count": 862476,
        "pct": 77.7023605958338,
        "remarks": null
      },
      "sc": {
        "count": 226557,
        "pct": 20.4110186364726,
        "remarks": null
      },
      "st": {
        "count": 20941,
        "pct": 1.88662076769366,
        "remarks": null
      },
      "total": {
        "count": 1109974,
        "pct": 100,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": null,
        "female": null,
        "total": null
      },
      "sc": {
        "male": 78.017,
        "female": 66.57,
        "total": 72.25
      },
      "st": {
        "male": null,
        "female": null,
        "total": null
      },
      "total": {
        "male": 78.017,
        "female": 66.57,
        "total": 72.25
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 5,
        "girls": 4,
        "total": 9
      },
      "sc": {
        "boys": 5,
        "girls": 4,
        "total": 9
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 57,
      "boys": {
        "count": 452,
        "classX_pct": 93,
        "classXII_pct": 90
      },
      "girls": {
        "count": 401,
        "classX_pct": 95,
        "classXII_pct": 95
      },
      "total": {
        "count": 853,
        "classX_pct": 94,
        "classXII_pct": 93
      },
      "teachers": {
        "general": {
          "sanctioned": 249,
          "actual": 33,
          "vacant_pct": 0.46
        },
        "sc": {
          "sanctioned": 125,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": 2,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 6,
      "boys": {
        "count": 21,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 22,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 43,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 11,
          "actual": 3,
          "vacant_pct": 73
        },
        "st": {
          "sanctioned": 1,
          "actual": 1,
          "vacant_pct": 0
        }
      }
    },
    "court_cases": {
      "pending": 3,
      "new_since_2026": 1,
      "more_than_1yr": 2,
      "contempt": 0,
      "ca_not_filed": 1
    },
    "cm_cell": {
      "pending": 2,
      "new": 0,
      "rating_a": 0,
      "rating_b": 5,
      "rating_c": 0
    },
    "rti": {
      "received": 6,
      "disposed": 6,
      "pending": 0,
      "appeal1": 0,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 0,
      "more_1yr": 0,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": 2,
      "villages_without": 2,
      "common_no_discrimination": 0,
      "encroachments": 0
    },
    "transport": {
      "no_public_transport": 5,
      "no_all_weather_roads": "Yes"
    },
    "drinking_water": {
      "connections_provided": 0,
      "pending": 0
    },
    "buildings": {
      "mobile network": {
        "y20_30": "Habitations without mobile network access",
        "y30_40": null,
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": "5 Villages"
    },
    "electricity": {
      "no_habitations": "No",
      "no_households": "No"
    }
  },
  {
    "name": "Villupuram",
    "blocks": 13,
    "highConcBlocks": "Olakkur (40%) Mailam (35%) Kandamangalam (35%) Vanur (35%)",
    "scstVillages40plus": 487,
    "scHabitations": 798,
    "stHabitations": 48,
    "population": {
      "general": {
        "count": 3458873,
        "pct": 76.02,
        "remarks": null
      },
      "sc": {
        "count": 1015716,
        "pct": 29.37,
        "remarks": null
      },
      "st": {
        "count": 74859,
        "pct": 2.16,
        "remarks": null
      },
      "total": {
        "count": 4549448,
        "pct": 107.55,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 80.55,
        "female": 63.15,
        "total": 71.88
      },
      "sc": {
        "male": 75.46,
        "female": 57.99,
        "total": 66.76
      },
      "st": {
        "male": 44.38,
        "female": null,
        "total": null
      },
      "total": {
        "male": null,
        "female": null,
        "total": null
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 37,
        "girls": 18,
        "total": 55
      },
      "sc": {
        "boys": 28,
        "girls": 13,
        "total": 41
      },
      "st": {
        "boys": 9,
        "girls": 5,
        "total": 14
      }
    },
    "section4_adw": {
      "schools": 63,
      "boys": {
        "count": 1799,
        "classX_pct": 0.837,
        "classXII_pct": 0.7313
      },
      "girls": {
        "count": 1945,
        "classX_pct": 0.873,
        "classXII_pct": 0.8041
      },
      "total": {
        "count": 3744,
        "classX_pct": 0.83,
        "classXII_pct": 0.76
      },
      "teachers": {
        "general": {
          "sanctioned": 65,
          "actual": 69,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 195,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "section4a_tw": {
      "schools": 1,
      "boys": {
        "count": 18,
        "classX_pct": null,
        "classXII_pct": null
      },
      "girls": {
        "count": 20,
        "classX_pct": null,
        "classXII_pct": null
      },
      "total": {
        "count": 38,
        "classX_pct": null,
        "classXII_pct": null
      },
      "teachers": {
        "general": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        },
        "sc": {
          "sanctioned": 1,
          "actual": null,
          "vacant_pct": null
        },
        "st": {
          "sanctioned": null,
          "actual": null,
          "vacant_pct": null
        }
      }
    },
    "court_cases": {
      "pending": 5,
      "new_since_2026": 1,
      "more_than_1yr": 5,
      "contempt": null,
      "ca_not_filed": 3
    },
    "cm_cell": {
      "pending": 9,
      "new": 19,
      "rating_a": null,
      "rating_b": 1,
      "rating_c": 1
    },
    "rti": {
      "received": 98,
      "disposed": 98,
      "pending": 0,
      "appeal1": 9,
      "appeal_commission": null
    },
    "pending_files": {
      "total": 1,
      "more_1yr": null,
      "more_3yr": null,
      "more_5yr": null
    },
    "burial_grounds": {
      "total_scst": 54,
      "villages_without": null,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "hostel": {
        "y20_30": 26,
        "y30_40": 9,
        "y40_plus": 9,
        "stability_cert": 6
      },
      "school": {
        "y20_30": 3,
        "y30_40": 2,
        "y40_plus": 53,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  },
  {
    "name": "Virudhunagar",
    "blocks": 11,
    "highConcBlocks": "Rajapalayam",
    "scstVillages40plus": null,
    "scHabitations": null,
    "stHabitations": 5,
    "population": {
      "general": {
        "count": 1540163,
        "pct": 79.2963247468965,
        "remarks": null
      },
      "sc": {
        "count": 399831,
        "pct": 20.5855671249578,
        "remarks": null
      },
      "st": {
        "count": 2294,
        "pct": 11.81,
        "remarks": null
      },
      "total": {
        "count": 1942288,
        "pct": null,
        "remarks": null
      }
    },
    "literacy": {
      "general": {
        "male": 0.543,
        "female": 0.456,
        "total": 0.908
      },
      "sc": {
        "male": 0.5552,
        "female": 0.445,
        "total": 0.635
      },
      "st": {
        "male": 0.577,
        "female": 0.423,
        "total": 0.547
      },
      "total": {
        "male": 0.545,
        "female": 0.455,
        "total": 0.85
      }
    },
    "section3_dropout": {
      "total": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "sc": {
        "boys": 1,
        "girls": 0,
        "total": 0
      },
      "st": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "section4_adw": {
      "schools": 20,
      "boys": {
        "count": 369,
        "classX_pct": 95.7,
        "classXII_pct": 81.4
      },
      "girls": {
        "count": 402,
        "classX_pct": 94.7,
        "classXII_pct": 100
      },
      "total": {
        "count": 774,
        "classX_pct": 95.2,
        "classXII_pct": 87.8
      },
      "teachers": {
        "general": {
          "sanctioned": 11,
          "actual": 6,
          "vacant_pct": 45
        },
        "sc": {
          "sanctioned": 68,
          "actual": 66,
          "vacant_pct": 2.9
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "section4a_tw": {
      "schools": 0,
      "boys": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "girls": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "total": {
        "count": 0,
        "classX_pct": 0,
        "classXII_pct": 0
      },
      "teachers": {
        "general": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "sc": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        },
        "st": {
          "sanctioned": 0,
          "actual": 0,
          "vacant_pct": 0
        }
      }
    },
    "court_cases": {
      "pending": 12,
      "new_since_2026": 0,
      "more_than_1yr": 10,
      "contempt": 0,
      "ca_not_filed": 1
    },
    "cm_cell": {
      "pending": 8,
      "new": 8,
      "rating_a": null,
      "rating_b": null,
      "rating_c": null
    },
    "rti": {
      "received": 92,
      "disposed": 71,
      "pending": 21,
      "appeal1": 7,
      "appeal_commission": 0
    },
    "pending_files": {
      "total": 1,
      "more_1yr": 1,
      "more_3yr": 0,
      "more_5yr": 0
    },
    "burial_grounds": {
      "total_scst": 893,
      "villages_without": 7,
      "common_no_discrimination": null,
      "encroachments": null
    },
    "transport": {
      "no_public_transport": null,
      "no_all_weather_roads": null
    },
    "drinking_water": {
      "connections_provided": null,
      "pending": null
    },
    "buildings": {
      "mobile network": {
        "y20_30": "No. of Habitations not have Mobile network access",
        "y30_40": "No. of HouuseHolds not have Electricity",
        "y40_plus": null,
        "stability_cert": null
      }
    },
    "mobile": {
      "no_mobile": null
    },
    "electricity": {
      "no_habitations": null,
      "no_households": null
    }
  }
];
export default DISTRICT_DATA;
